import React, { createElement, useEffect, useRef, useState } from 'react';
import { CropperRef, Cropper, FixedCropper, ImageRestriction } from 'react-advanced-cropper';
import './editor.css';
import 'react-advanced-cropper/dist/style.css';
import PreviewBg from '../../assets/images/design/preview-bg.png';
import PreviewBgApi from '../../assets/images/design/preview-bg0.png';
import { isMobile } from 'react-device-detect'

export const Editor = (props) => {

    const propImage = props?.image;
    const { imageUpdate } = props; // دریافت تابع imageUpdate از props
    const { isDefultImage } = props; // دریافت تابع imageUpdate از props
    const text = props.text;
    const color = props.color;
    const isDefult = props.isDefult;
    const font = props.font;
    const size = props.size;
    const resetImage = props.resetImage;

    const [image, setImage] = useState(null);  // This will hold the selected image
    const [defultImageBase, setDefultImageBase] = useState(false);  // This will hold the selected image
    const [selectedImage, setSelectedImage] = useState(null);  // Store the image selected by user
    useEffect(() => {
        updatePreview();
    }, [text, color, size, font, image, propImage])

    const updatePreview = () => {
        let element = document.createElement('div');
        element.textContent = text ?? '';
        element.classList.add('img-preview');
        element.style.setProperty('color', color, 'important');
        element.style.setProperty('font-family', font, 'important');
        element.style.setProperty('font-size', size + 'px', 'important');
        // Use no-logo background for on-screen preview
        element.style.setProperty('background-image', `url(${PreviewBg})`);
        setDefultImageBase(true)
        let target = document.getElementsByClassName('advanced-cropper-rectangle-stencil__preview')?.item(0);
        if (!!target) {
            target.innerHTML = '';
            target.appendChild(element)
        }
        updateResult();
    };
    const [resultImage, setResultImage] = useState(null);


    // Image Change event
    useEffect(() => {
        let image = propImage;
        if (!!image && typeof image === 'object') {
            const blob = URL.createObjectURL(image);
            setImage({
                src: blob,
                type: image.type
            });
        }
        else if (!!image && typeof image === 'string') {
            setImage({
                src: image,
            });
        }
        setTimeout(() => {
            updatePreview();

            if (isMobile) {
                zoom(1.1);
            }
            else {
                zoom(1.01);
            }
        }, 1100);
    }, [propImage]);

    useEffect(() => {
        return () => {
            if (image && image.src) {
                URL.revokeObjectURL(image.src);
            }
        };
    }, [image]);
    const updateResult = async (e = null) => {
        const cropperCanvas = e?.getCanvas() || cropperRef.current.getCanvas();
        if (!cropperCanvas) {
            return;
        }

        let cropperElement = document.getElementsByClassName('advanced-cropper-rectangle-stencil').item(0);
        const finalWidth = cropperElement.offsetWidth;
        const finalHeight = cropperElement.offsetHeight - 7.15; // 7.15 is the cancled transform in css

        const scaleFactor = 2; // مقیاس رزولوشن
        const canvas = document.getElementById('result-canvas');
        canvas.width = finalWidth * scaleFactor; // تنظیم عرض Canvas با درنظر گرفتن مقیاس
        canvas.height = finalHeight * scaleFactor; // تنظیم ارتفاع Canvas با درنظر گرفتن مقیاس
        const context = canvas.getContext('2d');

        // تنظیم مقیاس Canvas برای وضوح بالاتر
        context.scale(scaleFactor, scaleFactor);

        // رسم تصویر اصلی
        const mainImage = new Image();
        mainImage.src = cropperCanvas.toDataURL('image/png');
        await new Promise((resolve) => {
            mainImage.onload = () => {
                context.drawImage(mainImage, 0, 0, finalWidth, finalHeight);
                resolve();
            };
        });



        // رسم تصویر پس‌زمینه
        const PreviewImg = new Image();
        // Use legacy background (with logo) for the image sent to API/basket
        PreviewImg.src = PreviewBgApi;
        await new Promise((resolve) => {
            PreviewImg.onload = () => {
                context.drawImage(PreviewImg, 0, 0, finalWidth, finalHeight);
                resolve();
            };
        });

        // رسم متن
        if (text) {

            // پیدا کردن متن از کلاس img-preview
            const imgPreviewElement = document.querySelector('.img-preview');
            const previewText = imgPreviewElement ? imgPreviewElement.innerText : 'متن پیش‌فرض';
            // تعیین رنگ متن و بوردر
            const isWhiteText = color.toLowerCase() === "#ffffff" || color.toLowerCase() === "white";
            // اضافه کردن stroke و paint-order به عنصر img-preview
            if (imgPreviewElement) {
                imgPreviewElement.style.webkitTextStroke = `1.5px ${isWhiteText ? "black" : "white"}`; // استروک متن
                imgPreviewElement.style.paintOrder = 'stroke fill'; // ترتیب رسم استروک و متن
                imgPreviewElement.style.color = color; // رنگ متن
            }
            const borderColor = isWhiteText ? "black" : "white";

            context.font = `${size}px ${font}`; // متن با اندازه متناسب با مقیاس
            context.fillStyle = color;
            context.textAlign = 'center';
            context.textBaseline = 'bottom';

            const isMobile = window.innerWidth <= 768; // اگر عرض صفحه کمتر یا مساوی 768 باشد، موبایل در نظر گرفته می‌شود

            // رسم بوردر برای متن
            context.lineWidth = 1.5 * scaleFactor; // ضخامت بوردر
            context.strokeStyle = borderColor; // رنگ بوردر
            context.strokeText(previewText, finalWidth / 2, finalHeight - (isMobile ? 40 : 60)); // رسم بوردر متن


            context.fillText(text ? text : '', finalWidth / 2, finalHeight - (isMobile ? 40 : 60));
        }

        // به‌روزرسانی تصویر نهایی
        const finalImage = canvas.toDataURL('image/png');
        setResultImage(finalImage.replace(/^data:image\/png;base64,/, ''));
        if (imageUpdate) {
            imageUpdate(finalImage.replace(/^data:image\/png;base64,/, '')); // ارسال تصویر نهایی
        }
    };

    // Cropper Properties
    const cropperRef = useRef(null);
    const zoom = (scale) => {
        if (cropperRef.current) {
            cropperRef.current.zoomImage(scale); // zoom-in 2x
        }
    };
    const rotate = (angle) => {
        if (cropperRef.current) {
            cropperRef.current.rotateImage(angle);
        }
    };
    const move = (x = 0, y = 0) => {
        if (cropperRef.current && (x || y)) {
            cropperRef.current.moveImage(x, y); // move x = 50, y = 100
        }
    };


    const handleCropperClick = () => {

        console.log('is', image)
        if (isDefult || image?.src === "/static/media/image-default-bg.d0215f8539c9ad54697a4e6fa801e734.svg") {

            document.getElementById('uploadImage').click();

        }

    };

    // Handle file upload via FixedCropper click
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);  // Set the selected image
                setImage({
                    src: reader.result  // Also update the image to show in the FixedCropper
                });
            };



            reader.readAsDataURL(file);
            setTimeout(() => {
                isDefultImage({
                    src: reader.result  // Also update the image to show in the FixedCropper
                })
            }, 1000);
        }
    };
    const onReady = () => {
        console.log("ready am");

        setTimeout(() => {
            const item = document.getElementsByClassName("img-preview")?.item(0);
            console.log(item);
            item?.addEventListener("click", () => {
                console.log("clicked");

            })
        }, 1000);

    };
    return (
        <>
            <div className="flex flex-col  gap-3">
                <img className='help-img' src={require('../../assets/images/design/help.svg').default} width={171} alt="" />
                <div className="cropper-wrapper">
                    <FixedCropper
                        // onReady={onReady}
                        ref={cropperRef}
                        // stencilSize={stencilSize}
                        stencilProps={{
                            handlers: false,
                            lines: false,
                            movable: false,
                            resizable: false,
                        }}
                        stencilSize={{
                            width: 500,
                            height: 300
                        }}

                        imageRestriction={ImageRestriction.stencil}
                        onInteractionEnd={updateResult}
                        onTransitionsEnd={updateResult}
                        src={
                            image && image.src
                        }

                    />     <input
                        id="uploadImage"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleFileUpload}
                        accept="image/*"
                        className='img-upload'
                        disabled={!isDefult || image?.src != "/static/media/image-default-bg.d0215f8539c9ad54697a4e6fa801e734.svg"}  // Disable the input if the default image doesn't exist
                    />
                    {
                        (isDefult || image?.src === "/static/media/image-default-bg.d0215f8539c9ad54697a4e6fa801e734.svg") && (

                            <div onClick={handleCropperClick} style={{ width: '100%', height: '100%', background: 'transparent', position: 'absolute', top: '0', bottom: '0', left: '0', right: '0' }}>
                            </div>
                        )
                    }

                </div>
                {/* Hidden file input */}

                <div className="flex gap-3 justify-center mt-3 [&_.item]:hover:scale-[105%] [&_.item]:animation">
                    <div className='flex gap-1 '>
                        <button className='item' onClick={() => zoom(1.1)}>
                            <img src={require('../../assets/icons/editor/zoom-in.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => zoom(0.9)}>
                            <img src={require('../../assets/icons/editor/zoom-out.svg').default} alt="" />
                        </button>
                    </div>
                    <div className='flex gap-1'>
                        <button className='item' onClick={() => rotate(-90)}>
                            <img src={require('../../assets/icons/editor/rotate-left.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => rotate(90)}>
                            <img src={require('../../assets/icons/editor/rotate-right.svg').default} alt="" />
                        </button>
                    </div>
                    <div className='flex gap-1'>
                        <button className='item' onClick={() => move(-30, 0)}>
                            <img src={require('../../assets/icons/editor/move-right.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => move(30, 0)}>
                            <img src={require('../../assets/icons/editor/move-left.svg').default} alt="" />
                        </button>
                    </div>
                    <div className='flex gap-1'>
                        <button className='item' onClick={() => move(0, -30)}>
                            <img src={require('../../assets/icons/editor/move-down.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => move(0, 30)}>
                            <img src={require('../../assets/icons/editor/move-up.svg').default} alt="" />
                        </button>
                        <button className="item" onClick={() => { resetImage(); setImage({ src: propImage }); }}>
                            <img src={require('../../assets/icons/editor/close.svg').default} alt="" />

                        </button>
                    </div>

                </div>

                <div className="mt-5" style={{ display: 'none' }}>
                    {/* <img src={resultImage} alt="" /> */}
                    <canvas className='max-w-[100%]' id='result-canvas'></canvas>

                    {/* Final Image preview (just to debug, comment in product mode) */}
                    {/* <img src={textedImage} alt="" /> */}
                </div>
            </div>
        </>
    );
};

export default Editor;
